import React from 'react';
import Button from './Button';

const ButtonSecondary = ({
  className = '',
  ariaLabel='',
  ...args
}) => {
  return <Button className={`${className}`} ariaLabel={ariaLabel} {...args} />;
};

export default ButtonSecondary;
